import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteRssPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteRssPerk,
  {
    mutationKey: ['deleteRssPerk'],
  },
)
